import React from 'react';
import { makeStyles, DialogContent, Dialog } from '@material-ui/core';
import Loading from 'components/widgets/Loading';
import PropTypes from 'prop-types';
import FilePreviewStyles from 'styles/theme/Files/FilePreview';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';

const useStyles = makeStyles((theme) => FilePreviewStyles.getStyle(theme));

const FilePreviewer = ({ state, previewOnDialog, onClosePreview }) => {
    const classes = useStyles();

    const content = () => (
        <>
            {state.previewURL && state.previewExt === 'pdf' && (
                <iframe
                    className={classes.iframe}
                    title="Preview"
                    src={`${process.env.PUBLIC_URL}/pdfjs/web/viewer.html?file=${state.previewURL}`}
                    frameBorder="0"
                    allowFullScreen
                />
            )}
            {state.previewURL && state.previewExt !== 'pdf' && (
                <img
                    className={classes.innerImage}
                    alt="Preview"
                    src={state.previewURL}
                />
            )}
            {state.isProcessingFile && (
                <Loading className={classes.loader} />
            )}
        </>
    );

    return previewOnDialog ? (
        <>
            <Dialog
                open={state.isDialogOpen}
                fullWidth
                maxWidth="md"
                disableBackdropClick
                disableEscapeKeyDown
                scroll="paper"
                onMouseDown={(e) => e.stopPropagation()}
            >
                <DialogAppBar
                    appBarClassName={classes.AppBar}
                    title={`Document Preview ${state.previewTitle}`}
                    onClose={onClosePreview}
                    toolbarSize="md"
                />
                <DialogContent className={classes.dialog}>
                    {content()}
                </DialogContent>
            </Dialog>
        </>
    ) : (
        <div
            className={classes.preview}
        >
            <div>
                {`Document Preview ${state.previewTitle}`}
            </div>
            <div>
                {!state.previewURL && !state.isProcessingFile && (
                    <div>
                        Click on a document&apos;s name to preview
                    </div>
                )}
                {content()}
                {state.isProcessingFile && (
                    <Loading className={classes.loader} />
                )}
            </div>
        </div>
    );
};

FilePreviewer.propTypes = {
    state: PropTypes.shape({
        previewTitle: PropTypes.string,
        previewURL: PropTypes.string,
        previewExt: PropTypes.string,
        isProcessingFile: PropTypes.bool,
        isDialogOpen: PropTypes.bool,
    }),
    previewOnDialog: PropTypes.bool,
    onClosePreview: PropTypes.func,
};

FilePreviewer.defaultProps = {
    state: {
        previewTitle: null,
        previewURL: '',
        previewExt: '',
        isProcessingFile: false,
    },
    previewOnDialog: false,
    onClosePreview: () => null,
};
export default FilePreviewer;
